import React from 'react';
import { TouchTargetProps } from 'apps/sigma2-ui/src/components/ui/TouchTarget';
import { TertiaryButton } from 'apps/sigma2-ui/src/components/TertiaryButton';
import { useLanguage } from 'apps/sigma2-ui/src/lib/hooks/useLanguage';
import { SvgProps } from 'apps/sigma2-ui/src/components/svg/types';
import { toSvgColor } from 'apps/sigma2-ui/src/components/svg/types';

type EditRubricSelectButtonProps = Pick<TouchTargetProps, 'behavior'>;

const EditRubricSelectButtonIcon: React.FC<SvgProps> = (props) => {
  const strokeColor = toSvgColor('currentColor', props);
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="18"
      height="18"
      viewBox="0 0 18 18"
      fill="none"
    >
      <g>
        <path
          d="M9 16.5C13.1421 16.5 16.5 13.1421 16.5 9C16.5 4.85786 13.1421 1.5 9 1.5C4.85786 1.5 1.5 4.85786 1.5 9C1.5 13.1421 4.85786 16.5 9 16.5Z"
          stroke={strokeColor}
          strokeWidth="2"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M9 6V12"
          stroke={strokeColor}
          strokeWidth="2"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M6 9H12"
          stroke={strokeColor}
          strokeWidth="2"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </g>
    </svg>
  );
};

export const EditRubricSelectButton: React.FC<EditRubricSelectButtonProps> = ({
  behavior,
}) => {
  const language = useLanguage();
  return (
    <TertiaryButton
      label={language.editRubricSelectButtonLabel()}
      icon={<EditRubricSelectButtonIcon />}
      behavior={behavior}
    />
  );
};
